import { Typography } from 'antd'
import {
  CustomMenuItemType,
  NO_NAVIGATE_KEY,
} from '../../e-office-layout/components/dynamic-menu/custom-menu-items-type'
import IconGlobalApp from '../../../utils/IconGlobalApp'
import { DMS_PREFIX_URL, DMS_SHORT_PREFIX_URL } from './config.dms'
import {
  DOCUMENT_FOLDER_PREFIX_URL,
  DOCUMENT_LIST_PREFIX_URL,
  DOCUMENT_PREFIX_URL,
} from '../modules/document/constants/config.document'
import { DOCUMENT_TYPE_PREFIX_URL } from '../modules/document-type/constants/config.document-type'
import { DOCUMENT_ISSUING_DISCIPLINE_PREFIX_URL } from '../modules/document-issuing-discipline/constants/config.document-issuing-discipline'
import { DOCUMENT_PERMISSION_ACTION_PREFIX_URL } from '../modules/document-permission-action/constants/config.document-permission-action'
import { DOCUMENT_PERMISSION_ROLE_PREFIX_URL } from '../modules/document-permission-role/constants/config.document-permission-role'
import { DOCUMENT_DETAIL_PREFIX_URL } from '../modules/document-detail/constants/config.document-detail'

export const LIST_MENU_DOCUMENT_HRM: CustomMenuItemType<'submenu'> = {
  key: `${NO_NAVIGATE_KEY}-${DMS_SHORT_PREFIX_URL}`,
  icon: <IconGlobalApp name="folder-open" />,
  label: (
    <Typography.Link strong ellipsis title="Tài liệu">
      Tài liệu
    </Typography.Link>
  ),
  children: [
    {
      key: `${DMS_PREFIX_URL}${DOCUMENT_PREFIX_URL}/report`,
      label: 'Báo cáo thống kê',
    },
    {
      key: `${DMS_PREFIX_URL}${DOCUMENT_LIST_PREFIX_URL}`,
      label: 'Danh sách tài liệu',
    },
    {
      key: `${DMS_PREFIX_URL}${DOCUMENT_FOLDER_PREFIX_URL}`,
      label: 'Thư viện tài liệu',
    },
    {
      key: `${NO_NAVIGATE_KEY}${DOCUMENT_DETAIL_PREFIX_URL}`,
      label: (
        <span title="Phiên bản tài liệu của tôi">
          Phiên bản tài liệu của tôi
        </span>
      ),
      children: [
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_DETAIL_PREFIX_URL}/me`,
          label: 'Tôi có quyền xem',
        },
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_DETAIL_PREFIX_URL}/my-created`,
          label: 'Tôi tạo',
        },
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_DETAIL_PREFIX_URL}/my-draft`,
          label: 'Bản nháp',
        },
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_DETAIL_PREFIX_URL}/my-submitting`,
          label: <span title="Đang trình duyệt">Đang trình duyệt</span>,
        },
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_DETAIL_PREFIX_URL}/my-editing`,
          label: 'Đang chỉnh sửa',
        },
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_DETAIL_PREFIX_URL}/my-approved`,
          label: 'Đã được duyệt',
        },
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_DETAIL_PREFIX_URL}/my-rejected`,
          label: 'Từ chối duyệt',
        },
        {
          key: `${NO_NAVIGATE_KEY}${DOCUMENT_DETAIL_PREFIX_URL}-approval`,
          label: 'Phê duyệt',
          type: 'group',
          children: [
            {
              key: `${DMS_PREFIX_URL}${DOCUMENT_DETAIL_PREFIX_URL}/waiting-me-approve`,
              label: 'Chờ tôi duyệt',
            },
            {
              key: `${DMS_PREFIX_URL}${DOCUMENT_DETAIL_PREFIX_URL}/approved-by-me`,
              label: 'Tôi đã duyệt',
            },
          ],
        },
      ],
    },
    {
      key: `${NO_NAVIGATE_KEY}-${DMS_PREFIX_URL}`,
      label: 'Cấu hình',
      children: [
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_TYPE_PREFIX_URL}`,
          label: 'Loại tài liệu',
        },
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_ISSUING_DISCIPLINE_PREFIX_URL}`,
          label: 'Cơ quan ban hành',
        },
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_PERMISSION_ACTION_PREFIX_URL}`,
          label: 'Hành động phân quyền',
        },
        {
          key: `${DMS_PREFIX_URL}${DOCUMENT_PERMISSION_ROLE_PREFIX_URL}`,
          label: 'Phân quyền',
        },
      ],
    },
  ],
}
